import React from 'react';
import Button from '../extras/button';

/**
 * Contains the approval dialog for the setup viewer
 * @component
 * @alias SetupViewerApprovalConfirmation
 */
export default function ApprovalConfirmation(props) {
  return (
    <div id="approval-confirmation" className="approval-confirmation-container">
      <div className="modal-title">Approve Smile Design</div>
      <div className="modal-body-paragraph">
        InSmile Braces Case Approval represents your final and complete prescription order to Lorelli Technologies LLC. (Lorelli). As the treating physician,
        diagnosis, prescription, ordering and administering this appliance is your sole responsibility, and you waive any and all claims against Lorelli and
        Employees of Lorelli based on the failure of InSmile Braces to achieve a desired outcome, either alone or in combination with other appliances. All
        treatments submitted to Lorelli are governed by the details in effect at the time of each treatment submission and listed in the InSmile Braces{' '}
        <a className="midnight" href="/portal/agreement" target="_blank" rel="noopener noreferrer">
          Customer Agreement
        </a>
        . Lorelli reserves the right to refuse any prescription. By clicking 'Approve', I confirm I have read and understand the InSmile Braces Customer
        Agreement.
      </div>
      <div className="modal-button-group">
        <Button theme="success" onClick={props.confirm} disabled={props.disabled}>
          Approve
        </Button>
        <Button theme="secondary_outline" onClick={props.cancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
